
export abstract class DataObject {
    public static readonly urlName: string;

    protected _id: string;

    public constructor(id?: string) {
        this._id = id;
    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    public fromJSON(obj: any): DataObject {
        obj.id = obj._id;
        return this.fromObject(obj);
    }

    public abstract fromObject(obj: any): DataObject;

    public abstract toJSON(): any;

}


